var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},_vm._l((_vm.reservationTimes),function(reservationTimeItem){return _c('div',[_c('reservation-item',{attrs:{"reservation":_vm.reservation,"reservation-item":reservationTimeItem}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }